import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';

import AdminNavigation from '../siteadmin/AdminNavigation';
import Toaster from '../Toaster';
import LoadingBar from 'react-redux-loading-bar';

import { toggleAdminMenu } from '../../actions/siteadmin/modalActions';

import { AdminHamburgSvgIcon } from '../Common/Assets/SvgComponent/SiteAdminSvgIcon';

import s from './AdminHeading.css';
function AdminHeader({ toggleAdminMenu, isOpenMenu }) {

  return (
    <div>
        <Toaster />
        <LoadingBar />
        <header className={cx(s.adminHeaderContainer, 'adminHeaderContainerRtl', 'printViewNone')}>
          <button className={s.adminHamburgIconContainer} onClick={() => toggleAdminMenu(!isOpenMenu)}>
            <AdminHamburgSvgIcon />
          </button>
          <AdminNavigation />
        </header>
      </div>
  );
};

AdminHeader.propTypes = {
  borderLess: PropTypes.bool,
};

AdminHeader.defaultProps = {
  borderLess: false,
};

const mapState = (state) => ({
  isOpenMenu: state?.modalStatus?.isOpenAdminMenu,
});

const mapDispatch = {
  toggleAdminMenu
};

export default withStyles(s)(connect(mapState, mapDispatch)(AdminHeader));